// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navigation_wrapper__3gcGH","active":"navigation_active__3SMLk","container":"navigation_container__2XwpH","burgerButton":"navigation_burgerButton__Tm_vg"};